// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__o1CUx","notice":"styles_notice__4bFlC","text":"styles_text__9AHPo","primaryAction":"styles_primaryAction__V-7tk","supportText":"styles_supportText__rybpg"};